import { NavigationLink } from 'mm-ui-components/dist/src/base/components/navigation/header/primaryHeader/PrimaryHeader';
import { LinkButtonDataProps } from 'mm-ui-components/dist/src/base/components/navigation/utils';
import { MenuLinkDataProps } from 'mm-ui-components/dist/src/base/components/navigation/header/primaryHeader/menu/links/MenuSubLink';
import { INJECT_BUTTON_TO_MENU, INJECT_VIDEO_LOGO, InjectVideoLogoParams } from './primaryHeader.actions';
import { LinkButton } from '../utils/oldNavigation.utils';

type Link = {
    text: string;
    href: string;
};

export interface MenuLink extends Link {
    childrenLinks: Array<Link>;
}

interface MenuData {
    links: MenuLinkDataProps[];
    buttons?: Array<LinkButtonDataProps>;
}

interface Menu {
    links: Array<MenuLink>;
    buttons?: Array<LinkButton>;
}
export interface PrimaryHeaderState {
    logo: {
        svgLarge: string;
        svgSmall: string;
        svgLargeViewBox: string;
        svgSmallViewBox: string;
        alt: string;
        href: string;
    };
    links: NavigationLink[] | null;
    editions: NavigationLink[] | null;
    cta: Link | null;
    menu: MenuData | null;
    pagePath: string;
    editionEndpoint: string;
    videoLogo: InjectVideoLogoParams | null;
}

export interface InjectVideoLogoAction {
    type: typeof INJECT_VIDEO_LOGO;
    videoPath: string;
}

export interface InjectButtonToMenuAction {
    type: typeof INJECT_BUTTON_TO_MENU;
    onClick: string;
    text: string;
}

export type HomePageAction = InjectVideoLogoAction | InjectButtonToMenuAction;

export const primaryHeaderReducer = (state: PrimaryHeaderState = {} as PrimaryHeaderState, action: HomePageAction) => {
    switch (action.type) {
        case INJECT_VIDEO_LOGO: {
            const { videoPath } = action;
            return {
                ...state,
                videoLogo: {
                    videoPath,
                },
            };
        }
        case INJECT_BUTTON_TO_MENU: {
            const { text, onClick } = action;
            const buttons = state.menu && state.menu.buttons;
            return {
                ...state,
                menu: {
                    ...state.menu,
                    buttons: [
                        ...(buttons || []),
                        {
                            text,
                            onClick,
                        },
                    ],
                },
            };
        }
        default:
            return state;
    }
};
